import { DateTime } from "luxon";

/**
 * Banners are scheduled and shown in Eastern Time, whatever the browser's zone (MPN-2171).
 * Not AppDate: that follows the browser. The server stores UTC; only these helpers convert.
 */
export const ET_ZONE = "America/New_York";

/** A UTC ISO instant as an ET DateTime, for a picker's value. */
export function isoToEt(iso: string | null | undefined): DateTime | null {
    return iso ? DateTime.fromISO(iso, { zone: ET_ZONE }) : null;
}

/** An ET DateTime as a UTC ISO string for the server. A partly typed (invalid) value is null. */
export function etToIso(dt: DateTime | null | undefined): string | null {
    return dt?.isValid ? dt.toUTC().toISO({ suppressMilliseconds: true }) : null;
}

/** e.g. "Oct 20, 2026, 9:00 AM": ET wall clock without the suffix, for table cells. */
export function formatEtShort(value: string | DateTime | null | undefined): string {
    if (!value) return "";
    const dt = typeof value === "string" ? DateTime.fromISO(value) : value;
    if (!dt.isValid) return "";
    return dt.setZone(ET_ZONE).setLocale("en-US").toFormat("LLL d, yyyy, h:mm a");
}

/** e.g. "Oct 20, 2026, 9:00 AM ET". */
export function formatEt(value: string | DateTime | null | undefined): string {
    const short = formatEtShort(value);
    return short ? `${short} ET` : "";
}

/** The Live Now card's window line. */
export function liveWindowLabel({ starts_at, ends_at }: { starts_at: string | null; ends_at: string | null }): string {
    const end = ends_at ? `ends ${formatEt(ends_at)}` : "runs until turned off";
    return `Showing since ${formatEt(starts_at)} | ${end}`;
}
